var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8BCFB062-1B88-48A2-9D1D-09E92AC3152A@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Link-Donor-to-CRM---Bubble-Info",
    transform: "translate(-680.000000, -236.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688,242.857143 C688.315581,242.857143 688.571429,243.176952 688.571429,243.673469 L688.571429,247.755102 C688.571429,248.251619 688.315581,248.571429 688,248.571429 C687.684419,248.571429 687.428571,248.251619 687.428571,247.755102 L687.428571,243.673469 C687.428571,243.176952 687.684419,242.857143 688,242.857143 Z M688,239.2 C688.441128,239.2 688.8,239.55904 688.8,240.00036 C688.8,240.44128 688.441128,240.8 688,240.8 C687.558872,240.8 687.2,240.44128 687.2,240.00036 C687.2,239.55904 687.558872,239.2 688,239.2 Z M688,236 C692.4112,236 696,239.588848 696,244.000048 C696,248.411248 692.4112,252 688,252 C683.5888,252 680,248.411248 680,244.000048 C680,239.588848 683.5888,236 688,236 Z M688,250.4 C691.52896,250.4 694.4,247.529007 694.4,244.000047 C694.4,240.471087 691.529007,237.6 688,237.6 C684.470993,237.6 681.6,240.471087 681.6,244.000047 C681.6,247.529007 684.470993,250.4 688,250.4 Z",
    id: "Path-3-Copy-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoWhite);
export default __webpack_public_path__ + "static/media/iconInfoWhite.f475bc18a665cb53e5bfd2ae38cc878a.svg";
export { ForwardRef as ReactComponent };